import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { map, distinctUntilChanged, filter } from 'rxjs/operators';
import { SessionFacade, DealFacade } from '@ipreo/muni-shared';
import {
  WebsocketGatewayService,
  WebsocketGatewayAuthType
} from '@ipreo/northstar';

@Component({
  selector: 'gameday-direct-app',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  public readonly isAuthorized: Observable<
    boolean
  > = this.sessionFacade.session$.pipe(map(() => true));

  public readonly isLoading: Observable<
    boolean
  > = this.dealFacade.dealState$.pipe(map(dealState => dealState.loading));

  public readonly username: Observable<
    string
  > = this.sessionFacade.session$.pipe(map(session => session.name));

  constructor(
    private sessionFacade: SessionFacade,
    private dealFacade: DealFacade,
    private websocketGatewayService: WebsocketGatewayService
  ) { }

  ngOnInit() {
    this.sessionFacade.session$
      .pipe(
        filter(session => !!session.websocketGatewaySession),
        map(session => session.websocketGatewaySession.token),
        distinctUntilChanged()
      )
      .subscribe(token => {
        this.websocketGatewayService.connect(
          WebsocketGatewayAuthType.JWT,
          token
        );
      });
  }
}
